import { connect } from 'react-redux';
import { GelBox as Component } from './GelBox';
import {
  createGelBox,
  gelBoxOpen,
  toggleGelboxTooltipsControls
} from '@learningblocks/protocol-redux/lib/Actions';

function mapStateToProps(state, ownProps) {
  if(
    state.notebook.protocolSection.scene.apparatus.hasOwnProperty("gelBoxes") &&
    state.notebook.protocolSection.scene.apparatus.gelBoxes.some(
      trash => trash.id === ownProps.id
    )
  ){
   return {
     id: ownProps.id,
     type: state.notebook.protocolSection.scene.apparatus.gelBoxes[ownProps.id-1].type,
     open: state.notebook.protocolSection.scene.apparatus.gelBoxes[ownProps.id-1].open,
     showToolTipControls: state.notebook.protocolSection.scene.apparatus.gelBoxes[ownProps.id - 1].showToolTipControls,
   }
  } else {
   return {}
  }
}

function mapDispatchToProps(dispatch) {
  return {
    createGelBox: (data) => {
      dispatch(createGelBox(data))
    },
    gelBoxOpen: (data) => {
      dispatch(gelBoxOpen(data))
    },
    toggleToolTipControls: (data) => {
      dispatch(toggleGelboxTooltipsControls(data))
    }
  };
}
export const GelBox = connect(
  mapStateToProps,
  mapDispatchToProps
)(Component);
